import * as Yup from "yup";

const actionShape = Yup.object().shape({
  create: Yup.boolean(),
  read: Yup.boolean(),
  update: Yup.boolean(),
  delete: Yup.boolean(),
});

export const roleSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Nombre demaciado corto")
    .required("Campo requerido"),
  permissions: Yup.object().shape({
    users: actionShape,
    roles: actionShape,
    categories: actionShape,
    products: actionShape,
    branches: actionShape,
    dealers: actionShape,
    shippingCosts: actionShape,
    orders: actionShape,
    promotions: actionShape,
  }),
});
